import { style } from '@vanilla-extract/css';
import { recipe } from '@vanilla-extract/recipes';
import { vars } from '../../theme/contract.css';
import { glassPanelBase } from '../../styles/glass.css';

export const containerRecipe = recipe({
  base: {
    ...glassPanelBase,
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    border: `1px solid ${vars.surface.liquidGlass.innerSurface.border}`,
    borderRadius: '12px',
    backgroundColor: vars.surface.liquidGlass.innerSurface.background,
  },
  variants: {
    size: {
      sm: {
        padding: '24px 16px',
        gap: '8px',
      },
      md: {
        padding: '48px 32px',
        gap: '12px',
      },
      lg: {
        padding: '72px 48px',
        gap: '16px',
      },
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

export const iconWrapper = style({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  fontSize: '32px',
  color: vars.typography.textColor.tertiary,
  marginBottom: '4px',
  opacity: 0.7,
});

export const title = style({
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: vars.typography.fontSize.md,
  fontWeight: vars.typography.fontWeight.semibold,
  color: vars.typography.textColor.secondary,
  letterSpacing: vars.typography.letterSpacing.wide,
  lineHeight: String(vars.typography.lineHeight.snug),
  margin: 0,
});

export const description = style({
  fontFamily: vars.typography.fontFamily.primary,
  fontSize: vars.typography.fontSize.sm,
  fontWeight: vars.typography.fontWeight.regular,
  color: vars.typography.textColor.tertiary,
  letterSpacing: vars.typography.letterSpacing.wide,
  lineHeight: String(vars.typography.lineHeight.normal),
  margin: 0,
  maxWidth: '360px',
});

export const actionWrapper = style({
  marginTop: '8px',
});
